import React from 'react';
import Headline from '../../../general/Headline';

const InsightsComingSoon = () => {
     return (
          <div className='upcoming d-flex justify-content-between'>
               <Headline title='Coming Soon!'>
                    <p>We’ll soon have a full insights suite with prebuilt reports based on your data layer activity.</p>
               </Headline>
          </div>
     );
};

export default InsightsComingSoon;
